<template>
  <div class="jump-warphd nav-bar-fixed">
    <van-nav-bar title="发货单详情" left-arrow fixed @click-left="back" />

    <van-tabs v-model="tabActive" class="appr-tabs">
      <van-tab title="订单信息">
        <delivery-order-info :order="order" :appUser="appUser" v-if="order!=null && appUser!=null"></delivery-order-info>
        <delivery-goods-info
          :goodsList="orderGoods"
          :jamubiao="erp.jamubiao"
          v-on:jmbGoods="handlejmbGoods"
          v-if="orderGoods.length>0"
          style="display: none"
        ></delivery-goods-info>
      </van-tab>
      <van-tab title="商品信息">
        <delivery-goods-info
          :goodsList="orderGoods"
          :jamubiao="erp.jamubiao"
          v-on:jmbGoods="handlejmbGoods"
          v-if="orderGoods.length>0"
        ></delivery-goods-info>
      </van-tab>
      <van-tab title="发货信息">
        <div class="pay-by">
          <div class="appr-item">
            <van-row class="appr-item-head">
              <van-col span="12" class="appr-item-head-hd">
                <h5>
                  <van-icon name="edit" />审批信息流
                </h5>
              </van-col>
              <van-col span="12">
                <p class="item-r"></p>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <van-row
                  v-if="delivery.delay_work!=1 && deliverydata.delivery_status!=0 && deliverydata.delivery_status!=1"
                >
                  <van-field
                    v-model="workFlowTypeName"
                    readonly
                    label="审批延迟原因"
                    placeholder="请选择审批延迟原因"
                    @focus="showPop"
                    style="margin-left: -15px"
                  />
                </van-row>
                <van-row v-else></van-row>

                <van-popup v-model="popShow" position="bottom" :overlay="true">
                  <van-picker
                    :columns="columns"
                    show-toolbar
                    value-key="dictdata_value"
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
                  />
                </van-popup>
              </van-col>
            </van-row>
          </div>
          <div class="appr-item">
            <delivery-out-order
              v-bind:goodsList="deliveryGoods"
              v-bind:delivery="delivery"
              :workFlow="workFlow"
              :data="data"
              v-on:dataJson="handleFormData"
            ></delivery-out-order>
          </div>

          <van-radio-group v-model="radio">
            <van-cell-group v-for="dd in milkdeductamount.milkShopList">
              <van-cell v-bind:title="dd.orgName" clickable @click="radio = dd.orgCode">
                <van-radio :name="dd.orgCode" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <!-- 非入库原料贸易确认出库不显示 -->
          <van-row v-if="type!=0">
            <van-collapse
              v-model="tberp"
              v-if="workFlow.workflowType==4 && type!=2&& type!=7 || type==31 "
            >
              <van-collapse-item icon="edit" title="订单类型及发货信息" name="2">
                <div class="pay-hd-line">
                  <van-cell title="是否对接ERP">
                    <van-switch v-model="erp.isErp" @change="changeSynErp" />
                  </van-cell>
                  <van-row v-if="changeSynErps">
                    <van-cell title="赠品是否同步ERP" v-if="data.isPromotionGiveOrder">
                      <van-switch v-model="erp.isPromotionGiveOrder" />
                    </van-cell>

                    <van-cell title="使用价目表价格">
                      <van-switch v-model="erp.jamubiao" @change="syjmb" />
                    </van-cell>

                    <van-field
                      v-model="erp.entityValue"
                      readonly
                      label="业务实体"
                      placeholder="请选择"
                      @focus="entityShow"
                    />

                    <van-popup v-model="erp.entityPopShow" position="bottom" :overlay="true">
                      <van-picker
                        :columns="erp.entityColumns"
                        show-toolbar
                        value-key="ouName"
                        @cancel="entityCancel"
                        @confirm="entityConfirm"
                        @change="entityChange"
                      />
                    </van-popup>

                    <van-row v-if="orgIndex==2">
                      <van-field
                        v-model="org.value"
                        readonly
                        label="业务库"
                        placeholder="请选择"
                        @focus="orgShow"
                      />

                      <van-popup v-model="org.popShow" position="bottom" :overlay="true">
                        <van-picker
                          :columns="org.columns"
                          show-toolbar
                          value-key="organizationName"
                          @cancel="orgCancel"
                          @confirm="orgConfirm"
                          @change="orgChange"
                        />
                      </van-popup>
                    </van-row>
                  </van-row>
                </div>
                <div class="pay-hd-line" v-if="changeSynErps">
                  <van-field
                    v-model="dec.value"
                    readonly
                    label="发运方式"
                    placeholder="请选择"
                    @focus="decShow"
                  />
                  <van-popup v-model="dec.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="dec.columns"
                      show-toolbar
                      value-key="shipMethodMeaning"
                      @cancel="decCancel"
                      @confirm="decConfirm"
                      @change="decChange"
                    />
                  </van-popup>

                  <van-field
                    v-model="sec.value"
                    readonly
                    label="承运人"
                    placeholder="请选择"
                    @focus="secShow"
                  />
                  <van-popup v-model="sec.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="sec.columns"
                      show-toolbar
                      value-key="carrierName"
                      @cancel="secCancel"
                      @confirm="secConfirm"
                      @change="secChange"
                    />
                  </van-popup>

                  <van-field
                    v-model="odt.value"
                    readonly
                    label="订单类型"
                    placeholder="请选择"
                    @focus="odtShow"
                  />
                  <van-popup v-model="odt.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="odt.columns"
                      show-toolbar
                      value-key="orderTypeName"
                      @cancel="odtCancel"
                      @confirm="odtConfirm"
                      @change="odtChange"
                    />
                  </van-popup>

                  <van-field
                    v-model="jmb.value"
                    readonly
                    label="价目表"
                    placeholder="请选择"
                    @focus="jmbShow"
                  />
                  <van-popup v-model="jmb.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="jmb.columns"
                      show-toolbar
                      value-key="name"
                      @cancel="jmbCancel"
                      @confirm="jmbConfirm"
                      @change="jmbChange"
                    />
                  </van-popup>

                  <van-field
                    v-model="ptm.value"
                    readonly
                    label="付款条件"
                    placeholder="请选择"
                    @focus="ptmShow"
                  />
                  <van-popup v-model="ptm.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="ptm.columns"
                      show-toolbar
                      value-key="name"
                      @cancel="ptmCancel"
                      @confirm="ptmConfirm"
                      @change="ptmChange"
                    />
                  </van-popup>

                  <van-field
                    v-model="ywy.value"
                    readonly
                    label="业务员编码"
                    placeholder="请选择"
                    @focus="ywyShow"
                  />
                  <van-popup v-model="ywy.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="ywy.columns"
                      show-toolbar
                      @cancel="ywyCancel"
                      @confirm="ywyConfirm"
                      @change="ywyChange"
                    />
                  </van-popup>

                  <van-radio-group
                    v-model="sourceTypeCode"
                    v-if="data.isSuBmAudit ||workFlow.workflowType==4"
                  >
                    <van-cell-group>
                      <van-cell title="销转采订单">
                        <van-radio name="INTERNAL" style="float: left">否</van-radio>
                        <van-radio name="EXTERNAL" style="float: left">是</van-radio>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </div>

                <van-cell title="发货补充信息" />
                <van-field type="textarea" v-model="fhInfo" />
              </van-collapse-item>
            </van-collapse>
          </van-row>

          <van-collapse v-model="nk" class="pay-hd-item" v-if="order.payClass==3">
            <van-collapse-item icon="info-o" title="奶款信息" name="3">
              <van-cell title="奶量存量（公斤）" :value="milkdeductamount.milksystem_milk_amount" />
              <van-cell title="奶价（元/公斤）" :value="milkdeductamount.milk_price" />
              <van-cell title="银行还款信息（元/每月)" :value="milkdeductamount.repayment_money_month" />
              <van-cell title="其他扣款（元）" :value="milkdeductamount.other_deduct_amount" />
              <van-cell title="本月累计扣减奶款（元）" :value="milkdeductamount.deducted_milk_money_amount" />
              <van-cell
                title=" 累计预扣奶款（元）"
                :value="milkdeductamount.deducted_before_milk_money_amount"
              />
              <van-cell title="上月奶款结余（元）" :value="milkdeductamount.last_month_remain" />
              <van-cell title="奶款安全系数" :value="milkdeductamount.milk_safty_factor" />
              <van-cell title="奶款结余（元）" :value="milkdeductamount.milk_remain" />
              <van-cell
                title="本次订单扣减奶款（元）"
                :value="sumPrice | numFilter"
                v-if="(userRole.indexOf('BM')!=-1||userRole.indexOf('WM')!=-1||userRole.indexOf('TM')!=-1)&&data.isAllowed"
              />
              <van-cell
                title="预扣奶款（元）"
                :value="data.calculationPrice"
                v-if="workFlow.workflowType!=1 && workFlow.workflowType!=5  && workFlow.roleDeal=='BM'"
              />
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- 库管  调度扣款 不显示   !data.tmPass非入库原料分批贸易确认出库不显示 &&!data.confirmOut&&userRole.indexOf('WM')>=0-->
        <!--!data.rmPass&& type!=1&&!data.tmPass&&order.transport!='自提'&&!data.confirmOut&&userRole.indexOf('WM')>=0调度出库不显示-->
        <van-row v-if="!data.rmPass&& type!=1&&!data.tmPass&&order.transport!='自提'">
          <van-radio-group v-model="chetype" v-if="userRole.indexOf('WM')>=0 && type!=0">
            <van-cell-group>
              <van-cell title="车次安排">
                <van-radio name="1" style="float: left">专车</van-radio>
                <van-radio name="2" style="float: left">拼车</van-radio>
              </van-cell>
            </van-cell-group>
          </van-radio-group>

          <van-row v-if="userRole.indexOf('WM')!=-1 && type!=0">
            <van-cell-group>
              <van-field v-model="cheCode" label="车牌号" placeholder="请输入车牌号" @blur="getPhone" />

              <van-field v-model="phone" label="司机手机号" placeholder="请输入司机手机号" />
            </van-cell-group>

            <van-field
              v-model="birthday"
              label="发车时间"
              placeholder="请选择"
              @focus="showDate"
              readonly
            />
            <van-field v-model="driverName" label="司机姓名" placeholder="请输入司机姓名" />
            <van-field v-model="driverIdnumber" label="司机身份证号" placeholder="请输入司机身份证号" />

            <van-cell title="快捷录入" />
            <van-field
              type="textarea"
              v-model="speedy_input"
              @blur="getspeedy_input"
              placeholder="请输入快捷录入信息(逗号分隔)"
            />

            <van-popup v-model="popDateShow" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @cancel="popDateShow = false"
                @confirm="onDateConfirm"
              />
            </van-popup>
          </van-row>
        </van-row>
       <!-- 上传附件 -->
       <van-row v-if="data.confirmOut&&workFlow.workflowType==3">
         <van-col span="24">
     <van-uploader :after-read="onReadFiles" style="width:100%">
                            <van-field label="附件" readonly placeholder="请上传附件"/>
                        </van-uploader>
                        </van-col>
                        </van-row>

                         <van-row v-if="data.confirmOut&&workFlow.workflowType==3">
          <van-col span="8" v-for="pic in fileList" class="item">
                            <div style="position:relative">
                                <span class="delete" @click="deImgeFiles(pic.id)">×</span>
                                <img :src="pic.fileUrl"
                                     style="width:100%; height:102px;">
                            </div>
                        </van-col>
                    </van-row>


        <van-collapse v-model="activeNames" v-if="workflowFileList.length>0">
          <van-collapse-item title="附件清单" name="1">
            <van-cell-group v-for="obj in workflowFileList" style="border:5px solid  #f8f8f8">
              <div @click="picimg(obj.fileUrl)">
                <van-cell title="标题" :value="obj.title" />
                <van-cell title="上传人" :value="obj.userName" />
                <van-cell title="上传时间" :value="obj.createtime" />
              </div>
            </van-cell-group>
            <van-dialog v-model="picimgeshow">
              <img :src="picimgUrl" style="width:100%; height:auto;" />
            </van-dialog>
          </van-collapse-item>
        </van-collapse>

        <van-collapse v-model="activeNames" v-if="shipmentInfoLog.length>0">
          <van-collapse-item title="发货信息变更日志" name="2">
            <van-cell-group v-for="obj in shipmentInfoLog" style="border:5px solid  #f8f8f8">
              <div>
                <van-cell title="车辆类型" :value="obj.trainType==1?'专车':'拼车'" />
                <van-cell title="司机手机号" :value="obj.mobileDriver" />
                <van-cell title="司机车牌号" :value="obj.plateNo" />
                <van-cell title="发车时间" :value="obj.departureTime" />
                <van-cell title="司机姓名" :value="obj.driverName" />
                <van-cell title="司机身份证号" :value="obj.driverIdnumber" />
              </div>
            </van-cell-group>
          </van-collapse-item>
        </van-collapse>

        <van-row v-if="type==30" style="background-color: #fff;">
          <van-col span="24">
            <van-uploader :after-read="onRead">
              <van-field label="过磅单" readonly placeholder="请上传过磅单" />
            </van-uploader>
          </van-col>
          <van-col span="8" v-for="pic in urlList">
            <div>
              <span class="delete" @click="deImge(pic.id)">×</span>
              <img :src="pic.fileUrl" style="width:100%; height:102px;" />
            </div>
          </van-col>
          <!--<van-col span="24">
                        <van-button size="small" type="primary" style="margin-left: 10px"
                                    @click="seeImge">查看图片
                        </van-button>
                        <van-button size="small" type="primary" style="margin-left: 10px"
                                    @click="deImge">删除
                        </van-button>
                        <van-dialog
                                v-model="imgeshow"
                        >
                            <img :src="imgUrl" style="width:100%; height:auto;">
                        </van-dialog>
          </van-col>-->
        </van-row>
        <div
          v-if="!(!data.rmPass&& type!=1&&!data.tmPass&&order.transport!='自提'&&!data.confirmOut&&userRole.indexOf('WM')>=0 && type!=0)&&!(type==0&&workFlow.workflowType==10&&workFlow.status==0&&( ((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1) || (order.transport=='物流配送'&&userRole.indexOf('TM')!=-1))) && ( (type==7 ||type==31||type==30|| type==2|| (type==1 && workFlow.workflowType!=2)|| type==0)&&workFlow.workflowType!=2)"
          class="appr-item"
          style="margin-left: 10px;margin-right: 10px"
        >
          <van-row>
            <van-field :value="chetype==1?'专车':'拼车'" label="车次安排" readonly />
            <van-field :value="cheCode" label="车牌号" readonly />
            <van-field :value="phone" label="司机手机号" readonly />
            <van-field :value="birthday" label="发车时间" readonly />

            <van-field :value="driverName" label="司机姓名" readonly />
            <van-field :value="driverIdnumber" label="司机身份证号" readonly />
          </van-row>
        </div>

        <!-- 贸易（物流配送）/业务员修改发货信息（管车宝和自提） v-if="userRole.indexOf('WM')>=0 && type!=0" type==0&& userRole.indexOf('BM')!=-1&&workFlow.workflowType==10-->
        <van-row v-if="!isCai">
        <van-row
          v-if="type==0&&workFlow.workflowType==10&&workFlow.status==0&&( ((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1) || (order.transport=='物流配送'&&userRole.indexOf('TM')!=-1))"
        >
          <van-radio-group v-model="chetype">
            <van-cell-group>
              <van-cell title="车次安排">
                <van-radio name="1" style="float: left">专车</van-radio>
                <van-radio name="2" style="float: left">拼车</van-radio>
              </van-cell>
            </van-cell-group>
          </van-radio-group>

          <van-cell-group>
            <van-field v-model="cheCode" label="车牌号" placeholder="请输入车牌号" @blur="getPhone" />

            <van-field v-model="phone" label="司机手机号" placeholder="请输入司机手机号" />
          </van-cell-group>

          <van-field v-model="birthday" label="发车时间" placeholder="请选择" @focus="showDate" readonly />
          <van-field v-model="driverName" label="司机姓名" placeholder="请输入司机姓名" />
          <van-field v-model="driverIdnumber" label="司机身份证号" placeholder="请输入司机身份证号" />

          <van-cell title="快捷录入" />
          <van-field
            type="textarea"
            v-model="speedy_input"
            @blur="getspeedy_input"
            placeholder="请输入快捷录入信息(逗号分隔)"
          />

          <van-popup v-model="popDateShow" position="bottom" :overlay="true">
            <van-datetime-picker
              v-model="currentDate"
              type="datetime"
              @cancel="popDateShow = false"
              @confirm="onDateConfirm"
            />
          </van-popup>
        </van-row>
        </van-row>
        <!-- 采购单状态 -->

        <van-cell style="margin-top:10px" v-if="isCai">
          <van-col span="8" style="color:red">采购单订单状态:</van-col>
          <van-col
            span="16"
            style="color:red"
          >{{purOrderStatus=='createPurOSucess'?'已创建(请耐心等待SRM处理)':purOrderStatus}}</van-col>
        </van-cell>
        <van-radio-group v-model="shenhefangshi2" style="margin-top:10px" v-if="isCai">
          <van-cell-group>
            <van-cell title="请选择审核方式">
              <van-radio name="0" style="float: left" :disabled="true">自审</van-radio>
              <van-radio name="1" style="float: left">供审</van-radio>
            </van-cell>
          </van-cell-group>
        </van-radio-group>

        <van-row v-if="data.delivery_status==0 || data.delivery_status==5">
          <span style="margin-left: 15px">出库单备注</span>
          <van-field type="textarea" readonly :value="remark" />
        </van-row>
        <van-row v-else>
          <span style="margin-left: 15px">出库单备注</span>
          <van-field type="textarea" v-model="remark" />
        </van-row>

        <van-row>
          <van-col v-if="!isCai"   span="8">
          <van-col
            span="24"
            style="margin: 10px"
            v-if="type==0&&workFlow.workflowType==10&&workFlow.status==0&&( ((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1) || (order.transport=='物流配送'&&userRole.indexOf('TM')!=-1))"
          >
            <van-button type="info" size="large" class="blues" @click="shippingInfoEdit">确定修改</van-button>
          </van-col>
          </van-col>

          <van-col
            span="8"
            style="margin: 10px"
            v-if="data.isAllowed&&isEdit&&(type==1 || type==31)"
          >
            <van-button type="info" size="normal" class="blues" @click="deliverGoodsNum">确认扣款</van-button>
          </van-col>
          <van-col span="8" style="margin: 10px" v-if="data.confirmOut">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderConfirmSave"
            >确认出库</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.deliveryGoods">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderSendGoodsSave"
            >发货</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.rmPass">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderRmAuditSave"
            >通过</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.fmPass">
            <van-button type="info" size="normal" class="blues" @click="deliverGoodsNum">通过</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.confirmReceiveCount">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsOrderSaveReceivedCount"
            >确认到货量</van-button>
          </van-col>
          <van-col span="8" style="margin: 10px"  v-if="data.confirmReceiveCount">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderCancelSave"
              v-if="isCai&&delivery.delivery_goodsorder_status==30"
            >取消出库</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.tmPass">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderRmAuditSave"
            >通过</van-button>
          </van-col>

          <van-col span="8" style="margin: 10px" v-if="data.cancelOut">
            <van-button
              type="info"
              size="normal"
              class="blues"
              @click="deliveryGoodsorderCancelSave"
            >取消出库</van-button>
          </van-col>
        </van-row>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import {
  Uploader,
  Button,
  Cell,
  CellGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  NavBar,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Row,
  Switch,
  Tab,
  Tabs
} from "vant";
import DeliveryOrderInfo from "../../components/DeliveryOrderInfo";
import DeliveryGoodsInfo from "../../components/DeliveryGoodsInfo";
import OutOrderComponent from "../../components/OutOrderComponent";

export default {
  name: "ApprovalDetail",
  components: {
    [Uploader.name]: Uploader,
      [Field.name]: Field,
    [Dialog.name]: Dialog,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Switch.name]: Switch,
    "delivery-order-info": DeliveryOrderInfo,
    "delivery-goods-info": DeliveryGoodsInfo,
    "delivery-out-order": OutOrderComponent
  },
  data() {
    return {
      isCai: false,
      purOrderStatus: "", //采购单状态
      shenhefangshi2: "1", //采购单的审核方式
      cancelreason: "", //取消原因
      cancelRemark: "", //取消说明
      changeSynErps: true,
      activeNames: ["0"],
      userRole: localStorage.getItem("userRole"),
      remark: "",
      type: this.$route.query.type,
      isEdit: this.$route.query.isEdit,
      nk: ["3"],
      columns: [],
      tabActive: 1,
      order: {},
      appUser: {},
      milkdeductamount: {},
      orderGoods: [],
      workFlowTypeName: "",
      workFlowTypeId: "",
      workflowId: "",
      popShow: false, //延迟审批pop
      checkDelay: false,
      delivery: {},
      deliveryGoods: [],
      deliverydata: {},
      isEdit: this.$route.query.isEdit,
      radio: "",
      tberp: ["2"],
      activeNames: ["1"],
      orderGoods: [],
      data: {},
      erp: {
        isErp: true,
        isPromotionGiveOrder: false,
        jamubiao: false,
        entityValue: "",
        entityColumns: [],
        entityPopShow: false,
        entityId: ""
      },
      org: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      dec: {
        id: "",
        value: "",
        code: "",
        popShow: false,
        columns: []
      },
      sec: {
        id: "",
        value: "",
        code: "",
        popShow: false,
        columns: []
      },
      odt: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      jmb: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      ptm: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      ywy: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      orgIndex: 0,
      fhInfo: "",
      sourceTypeCode: "INTERNAL",
      order: {},
      chetype: "1",
      cheCode: "",
      phone: "",
      birthday: "",
      driverName: "",
      driverIdnumber: "",
      speedy_input: "",
      popDateShow: false,
      currentDate: new Date(),
      workFlow: {},
      isNotNull: "",
      erpJson: {},
      dataJson: {
        deliveryPrice: [],
        outCount: [],
        receivedCount: []
      },
      shenhefangshi: "0",
      accessoryId: "",
      imgUrl: "",
      imgeshow: false,
      workflowFileList: [],
      picimgUrl: "",
      picimgeshow: false,
      jmbGoods: "",
      urlList: [],
      shipmentInfoLog: [],
      isUplodReceivedCount: false,
      sumPrice: 0,
      failCode: "",
      fileList:[]//附件列表
    };
  },
  created (){
    this.onDateConfirm(this.currentDate)
  },
  mounted() {
    var order_id = this.$route.query.orderId;
    var deliveryId = this.$route.query.outId;
    var status = this.$route.query.status;
    this.workflowId = this.$route.query.workflowId;
    let that = this;
    this.$api.get(
      that.jumuc.userCenter.deliveryDetail,
      {
        order_id: order_id,
        delivery_ordergoods_id: deliveryId,
        delivery_status: status == 1 ? "" : status
      },
      successRes => {
        if (successRes.success) {
          that.tabActive = 2;
          that.shipmentInfoLog = successRes.data.shipmentInfoLog;
          that.workFlow = successRes.data.workFlow;
          that.data = successRes.data;
          that.order = successRes.data.orders;
          that.appUser = successRes.data.appUser;
          that.milkdeductamount = successRes.data.appUser; //奶款信息
          try {
            // if (that.data.isSuBmAudit) {
            that.ywy.value = that.milkdeductamount.businessManUserCode.split(
              ","
            )[0];
            that.ptm.value = "立即付款";
            that.ptm.id = "1001";
            // }
          } catch (e) {}
          that.orderGoods = successRes.data.orderGoods; //商品信息
          that.delivery = successRes.data.deliveryGoodsorder; //发货单信息
          if (successRes.data.deliveryGoodsorder.approval_type == 1) {
            //已经生成过采购单
            this.isCai = true;
            this.purOrderStatus =
              successRes.data.deliveryGoodsorder.pur_order_status;
          }

          that.remark = that.delivery.remark;
          that.deliveryGoods =
            successRes.data.deliveryGoodsorder.outOrderDetail; //发货商品信息
          try {
            that.chetype = that.delivery.faHuo.train_type + "";
            that.phone = that.delivery.faHuo.mobile_driver;
            that.cheCode = that.delivery.faHuo.plate_no;
            that.birthday = that.delivery.faHuo.departure_time;
            that.driverName = that.delivery.faHuo.driverName;
            that.driverIdnumber = that.delivery.faHuo.driverIdnumber;
            for (var i = 0; i < that.appUser.milkShopList.length; i++) {
              if (
                successRes.data.appUser.checkedOrgId ==
                that.appUser.milkShopList[i].id
              ) {
                that.radio = that.appUser.milkShopList[i].orgCode;
              }
            }
          } catch (e) {
          } finally {
            that.sumPrice = that.delivery.finalDeductAmount;
            that.workflowFileList = successRes.data.workflowFileList;
            var workflowFileList = successRes.data.workflowFileList;
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].id;
              json["fileUrl"] = workflowFileList[i].fileUrl;
              that.urlList[i] = json;
               that.fileList[i] = json;
            }
          }
        }
      }
    );
    //
    this.getDictionaryByCode(); //延迟原因
  },
  methods: {
    picimg(picimgUrl) {
      let that = this;
      that.picimgUrl = picimgUrl;
      that.picimgeshow = true;
    },
    changeSynErp(checked) {
      this.changeSynErps = checked;
    },
    seeImge() {
      let that = this;
      if (that.imgUrl == "") {
        that.$toast("请先上传过磅单");
      } else {
        that.imgeshow = true;
      }
    },
    deImge(id) {
      let that = this;
      that.$api.get(that.data.deleteImgUrl, { picId: id }, successRes => {
        if (successRes.result) {
          that.urlList = [];
          let workflowFileList = successRes.data;
          for (let i = 0; i < workflowFileList.length; i++) {
            let json = {};
            json["id"] = workflowFileList[i].picId;
            json["fileUrl"] = workflowFileList[i].url;
            that.urlList[i] = json;
          }
          that.$toast("删除成功");
        } else {
          that.$toast("删除失败");
        }
      });
    },
    onRead(file, detail) {
      let that = this;
      let fileFormData = new FormData();
      fileFormData.append("file", file.file);
      let fileType = 1;
      if (that.data.isTmDealOne) {
        fileType = 0;
      } else if (that.data.isTmDealTwo || that.data.isBmDealTwo) {
        fileType = 1;
      }
      let delivery = 1;
      if (that.order.isPartOut == 1) {
        delivery = 0;
      }
      fileFormData.append("userId", localStorage.getItem("userId"));
      fileFormData.append("fileType", fileType);
      fileFormData.append("workflowId", that.data.workFlow.id);
      fileFormData.append("delivery", delivery);
      that.$api.post(that.data.uploadUrl, fileFormData, successRes => {
        if (successRes.result) {
          that.urlList = [];
          let workflowFileList = successRes.data;
          for (let i = 0; i < workflowFileList.length; i++) {
            let json = {};
            json["id"] = workflowFileList[i].picId;
            json["fileUrl"] = workflowFileList[i].url;
            json["file_type"] = workflowFileList[i].file_type;
            that.urlList[i] = json;
          }
          that.$toast("上传成功!");
        } else {
          that.$toast("上传失败!");
        }
      });
    },
    shippingInfoEdit() {
      let that = this;
      let erpJson = {
        workflowId: that.data.workFlow.id,
        deliveryId: that.delivery.id,
        departureTime: that.birthday,
        driverName: that.driverName,
        driverIdnumber: that.driverIdnumber,
        plateNo: that.cheCode,
        mobileDriver: that.phone,
        trainType: that.chetype
      };
      that.$api.post(that.jumuc.stock.saveDriver, erpJson, successRes => {
        Dialog.alert({
          title: "",
          message: successRes.msg
        }).then(() => {
          if (successRes.success) {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          }
        });
      });
    },
    deliveryGoodsorderCancelSave(type) {
      //取消出库
      let that = this;
      that.erpJson["deliveryGoodsorderId"] = that.delivery.id;
      that.erpJson["orderId"] = that.delivery.orderId;
      that.erpJson["remark"] = that.remark;
      console.log(that.remark);
      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsorderCancelSave,
        that.erpJson,
        successRes => {
          if (successRes.success) {
            Dialog.alert({
              title: "",
              message: successRes.msg
            }).then(() => {
              that.$router.push({
                path: "/staff/delivery/list"
              });
            });
          } else {
              Dialog.alert({
              title: "",
              message: successRes.msg
            }).then(() => {
              
            });
          }
        }
      );
    },
    deliveryGoodsorderRmAuditSave() {
      //库管审核通过
      let that = this;
      that.erpJson["deliveryGoodsorderId"] = that.delivery.id;
      that.erpJson["status"] = "7";
      if (that.data.tmPass) {
        that.erpJson["status"] = "10";
      }
      that.erpJson["orderId"] = that.order.id;
      that.erpJson["isMilkShopGoods"] = "0";
      that.erpJson["orgMilkShop"] = "";
      that.erpJson["shipInfo"] = "";
      that.erpJson["departureTime"] = that.birthday;
      that.erpJson["plateNo"] = that.cheCode;
      that.erpJson["mobileDriver"] = that.phone;
      that.erpJson["driverName"] = that.driverName;
      that.erpJson["driverIdnumber"] = that.driverIdnumber;
      that.erpJson["transport"] = "";
      that.erpJson["trainType"] = that.chetype;
      let detailData = [];
      let outOrderDetail = that.delivery.outOrderDetail;
      for (var i = 0; i < outOrderDetail.length; i++) {
        let json = {};
        json["delivery_goodsOrder_detail_id"] = outOrderDetail[i].id;
        json["goods_id"] = outOrderDetail[i].goods_id;
        json["delivery_price"] = that.dataJson.deliveryPrice[i];
        json["delivery_count"] = that.dataJson.outCount[i];
        json["suppler_id"] = outOrderDetail[i].suppler_id;
        json["istongbu"] = "";
        json["goods_out_code"] = outOrderDetail[i].goods_out_code;
        json["erp_price"] = outOrderDetail[i].erp_price;
        json["isGift"] = outOrderDetail[i].gift_flag == 0 ? false : true;
        detailData.push(json);
      }
      that.erpJson["detailData"] = JSON.stringify(detailData);

      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsorderRmAuditSave,
        that.erpJson,
        successRes => {
          Dialog.alert({
            title: "",
            message: successRes.msg
          }).then(() => {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          });
        }
      );
    },
    deliveryGoodsorderConfirmSave() {
      //确认出库
      let that = this;
      that.erpJson["deliveryGoodsorderId"] = that.delivery.id;
      that.erpJson["status"] = "1";
      that.erpJson["orderId"] = that.order.id;
      that.erpJson["isMilkShopGoods"] = "0";
      that.erpJson["orgMilkShop"] = "";
      that.erpJson["shipInfo"] = "";
      that.erpJson["departureTime"] = that.birthday;
      that.erpJson["driverName"] = that.driverName;
      that.erpJson["driverIdnumber"] = that.driverIdnumber;
      that.erpJson["plateNo"] = that.cheCode;
      that.erpJson["mobileDriver"] = that.phone;
      //add by wangting 确认将配送方式传到后台 若是自提不校验发运信息是否为空 2019-09-21
      that.erpJson["transport"] = that.delivery.faHuo.transport;
      that.erpJson["trainType"] = that.chetype;
      let detailData = [];
      let outOrderDetail = that.delivery.outOrderDetail;
      for (var i = 0; i < outOrderDetail.length; i++) {
        let json = {};
        json["delivery_goodsOrder_detail_id"] = outOrderDetail[i].id;
        json["goods_id"] = outOrderDetail[i].goods_id;
        json["delivery_price"] = that.dataJson.deliveryPrice[i];
        json["delivery_count"] = that.dataJson.outCount[i];
        json["suppler_id"] = outOrderDetail[i].suppler_id;
        json["istongbu"] = "";
        json["goods_out_code"] = outOrderDetail[i].goods_out_code;
        json["erp_price"] = outOrderDetail[i].erp_price;
        json["isGift"] = outOrderDetail[i].gift_flag == 0 ? false : true;
        detailData.push(json);
      }
      that.erpJson["detailData"] = JSON.stringify(detailData);

      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsorderConfirmSave,
        that.erpJson,
        successRes => {
          Dialog.alert({
            title: "",
            message: successRes.msg
          }).then(() => {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          });
        }
      );
    },
    deliverGoodsNum() {
      //确认扣款
      let that = this;
      that.erpJson["deliveryGoodsorderId"] = that.delivery.id;
      that.erpJson["finalDeductAmount"] = that.sumPrice;
      that.erpJson["squence"] = that.workFlow.currentSquence;
      that.erpJson["status"] = "6";
      that.erpJson["orderId"] = that.delivery.orderId;
      if (that.type == 31) {
        let receivedCountJson = "";
        for (var i = 0; i < that.deliveryGoods.length; i++) {
          receivedCountJson =
            receivedCountJson +
            that.deliveryGoods[i].goods_out_code +
            "-" +
            that.dataJson.receivedCount[i] +
            ",";
        }
        that.erpJson["receivedCounts"] = receivedCountJson;
        that.erpJson["priceListGoodsPrice"] = that.jmbGoods;
        that.erpJson["syncErp"] = that.erp.isErp == true ? 1 : 0;
        if (that.erp.isErp) {
          //同步erp
          that.getIsNotNull();
          if (that.isNotNull != "") {
            that.$toast(that.isNotNull);
            return false;
          }
        }
      }
      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsorderDeductSave,
        that.erpJson,
        successRes => {
          Dialog.alert({
            title: "",
            message: successRes.msg
          }).then(() => {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          });
        }
      );
    },
    deliveryGoodsorderSendGoodsSave() {
      //发货
      let that = this;
      that.erpJson["deliveryGoodsorderId"] = that.delivery.id;
      that.erpJson["finalDeductAmount"] = that.delivery.finalDeductAmount;
      that.erpJson["squence"] = that.workFlow.currentSquence;
      that.erpJson["status"] = "6";
      that.erpJson["orderId"] = that.delivery.orderId;
      if (that.type == 31) {
        let receivedCountJson = "";
        for (var i = 0; i < that.deliveryGoods.length; i++) {
          receivedCountJson =
            receivedCountJson +
            that.deliveryGoods[i].goods_out_code +
            "-" +
            that.dataJson.receivedCount[i] +
            ",";
        }
        that.erpJson["receivedCounts"] = receivedCountJson;
        that.erpJson["priceListGoodsPrice"] = that.jmbGoods;
        that.erpJson["syncErp"] = that.erp.isErp == true ? 1 : 0;
        if (that.erp.isErp) {
          //同步erp
          that.getIsNotNull();
          if (that.isNotNull != "") {
            that.$toast(that.isNotNull);
            return false;
          }
        }
      }
      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsorderSendGoodsSave,
        that.erpJson,
        successRes => {
          Dialog.alert({
            title: "",
            message: successRes.msg
          }).then(() => {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          });
        }
      );
    },
    getIsUplodReceivedCount() {
      let that = this;
      that.isUplodReceivedCount = false;
      for (var k = 0; k < that.urlList.length; k++) {
        if (that.urlList[k].file_type == 1) {
          that.isUplodReceivedCount = true;
        }
      }
    },
    deliveryGoodsOrderSaveReceivedCount() {//确认到货量 
     if(this.purOrderStatus=='createPurOSucess'){
           Dialog.alert({
            title: "",
            message: 'SRM采购订单状态为已创建，不允许修改到货量！'
          }).then(() => {
           
          });
     }else if(this.purOrderStatus=='已拒绝'){
             Dialog.alert({
            title: "",
            message: 'SRM采购订单状态为已拒绝，请取消出库！'
          }).then(() => {
           
          });
     }else{
          let that = this;
      that.erpJson["delivery_goodsorder_id"] = that.delivery.id;
      let receivedCountJson = [];
      let isReceivedCount = false;
      for (var i = 0; i < that.deliveryGoods.length; i++) {
        let json = {};
        json["id"] = that.deliveryGoods[i].id;
        json["deliveryCount"] = that.dataJson.receivedCount[i];
        receivedCountJson[i] = json;
        if (
          that.deliveryGoods[i].received_count != that.dataJson.receivedCount[i]
        ) {
          isReceivedCount = true;
        }
      }
      that.getIsUplodReceivedCount();
      if (that.isUplodReceivedCount == false && isReceivedCount) {
        that.$toast("发货数量和到货数量不一致请上传过磅单");
        return false;
      }
      that.erpJson["receivedCountJson"] = receivedCountJson;
      that.$api.post(
        that.jumuc.userCenter.deliveryGoodsOrderSaveReceivedCount,
        that.erpJson,
        successRes => {
          Dialog.alert({
            title: "",
            message: successRes.msg
          }).then(() => {
            that.$router.push({
              path: "/staff/delivery/list"
            });
          });
        }
      );
     }
      
    },
    getDictionaryByCode() {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getDictionaryByCode,
        { entrycode: 401 },
        successRes => {
          that.columns = successRes.data;
        }
      );
    },
    // change(index, title) {
    //   if (index == 2) {
    //   }
    // },
    back() {
      this.$router.push({
        path: "/staff/delivery/list"
      });
    },
    onPickerCancel() {
      this.popShow = false;
    },
    onPickerConfirm(values) {
      let that = this;
      this.workFlowTypeName = values.dictdata_value;
      this.workFlowTypeId = values.id;
      this.popShow = false;
      that.$api.post(
        that.jumuc.stock.changeDealyDeal,
        { workflowId: that.data.workFlow.id, remarkId: values.id },
        successRes => {
          that.$toast(successRes.msg);
          if (successRes.success) {
            that.checkDelay = true;
          }
        }
      );
    },
    onPickerChange(picker, values) {
      picker.setColumnValues(1, values.dictdata_value);
    },
    showPop() {
      let that = this;
      that.popShow = true;
    },
    entityShow() {
      //选择业务实体部分
      let that = this;
      that.getOuByCus(); //erp信息-获取业务实体
      that.entIndex = 1;
      that.erp.entityPopShow = true;
    },
    entityCancel() {
      let that = this;
      that.erp.entityPopShow = false;
    },
    entityConfirm(values) {
      let that = this;
      that.erp.entityValue = values.ouName;
      that.erp.entityId = values.orgId;
      that.erp.entityPopShow = false;
      that.entIndex = 2;
      that.orgIndex = 2;
    },
    entityChange(picker, values) {
      let that = this;
      that.org.value = "";
      that.dec.value = "";
      that.sec.value = "";
      that.odt.value = "";
      that.jmb.value = "";
      that.ptm.value = "";
      that.erp.jamubiao = false;
      picker.setColumnValues(1, values[0].ouName);
    },
    orgShow() {
      //选择业务库部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOrgByOuId,
        { ouId: that.erp.entityId },
        successRes => {
          that.org.columns = JSON.parse(successRes.data).data;
        }
      );
      that.org.popShow = true;
    },
    orgCancel() {
      let that = this;
      that.org.popShow = false;
    },
    orgConfirm(values) {
      let that = this;
      that.org.value = values.organizationName;
      that.org.id = values.organizationId;
      that.org.popShow = false;
      that.entIndex = 3;
    },
    orgChange(picker, values) {
      let that = this;
      that.dec.value = "";
      that.sec.value = "";
      picker.setColumnValues(1, values.organizationName);
    },
    decShow() {
      //选择发运方式部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getShimpmenthodEc,
        { organizationId: that.org.id },
        successRes => {
          that.dec.columns = JSON.parse(successRes.data).data;
        }
      );
      that.dec.popShow = true;
    },
    decCancel() {
      let that = this;
      that.dec.popShow = false;
    },
    decConfirm(values) {
      let that = this;
      that.dec.value = values.shipMethodMeaning;
      that.dec.id = values.carrierId;
      that.dec.code = values.shipMethodCode;
      that.dec.popShow = false;
      that.entIndex = 4;
    },
    decChange(picker, values) {
      let that = this;
      that.sec.columns = [];
      that.sec.value = "";
      picker.setColumnValues(1, values.shipMethodMeaning);
    },
    secShow() {
      //选择承运人部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getCarriersEc,
        { organizationId: that.org.id, carrierId: that.dec.id },
        successRes => {
          that.sec.columns = JSON.parse(successRes.data).data;
        }
      );
      that.sec.popShow = true;
    },
    secCancel() {
      let that = this;
      that.sec.popShow = false;
    },
    secConfirm(values) {
      let that = this;
      that.sec.value = values.carrierName;
      that.sec.id = values.carrierId;
      that.sec.code = values.freightCode;
      that.sec.popShow = false;
      that.entIndex = 5;
    },
    secChange(picker, values) {
      picker.setColumnValues(1, values.carrierName);
    },
    odtShow() {
      //选择订单类型部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOrderTypeListByOuId,
        { ouId: that.erp.entityId, typeCode: "ORDER" },
        successRes => {
          that.odt.columns = JSON.parse(successRes.data).data;
        }
      );
      that.odt.popShow = true;
    },
    odtCancel() {
      let that = this;
      that.odt.popShow = false;
    },
    odtConfirm(values) {
      let that = this;
      that.odt.value = values.orderTypeName;
      that.odt.id = values.orderTypeId;
      that.odt.popShow = false;
      that.entIndex = 6;
    },
    odtChange(picker, values) {
      picker.setColumnValues(1, values.orderTypeName);
    },
    jmbShow() {
      //价目表部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getPriceListByOuIdAndOrderId,
        { ouId: that.erp.entityId, workFlowId: that.workFlow.id },
        successRes => {
          that.jmb.columns = JSON.parse(successRes.data).data;
        }
      );
      that.jmb.popShow = true;
    },
    jmbCancel() {
      let that = this;
      that.jmb.popShow = false;
    },
    jmbConfirm(values) {
      let that = this;
      that.jmb.value = values.name;
      that.jmb.id = values.listHeaderId;
      that.jmb.popShow = false;
      that.entIndex = 7;
      localStorage.setItem("jmbid", values.listHeaderId);
      that.getGoodsPriceByPriceListIdAndGoodsId();
    },
    jmbChange(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    ptmShow() {
      //选择付款条件部分
      let that = this;
      that.$api.post(that.jumuc.userCenter.getPaymentTerm, null, successRes => {
        that.ptm.columns = JSON.parse(successRes.data).data;
      });
      that.ptm.popShow = true;
    },
    ptmCancel() {
      let that = this;
      that.ptm.popShow = false;
    },
    ptmConfirm(values) {
      let that = this;
      that.ptm.value = values.name;
      that.ptm.id = values.paymentTermId;
      that.ptm.popShow = false;
      that.entIndex = 8;
    },
    ptmChange(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    ywyShow() {
      //选择业务编码部分
      let that = this;
      that.ywy.columns = that.milkdeductamount.businessManUserCode.split(",");
      that.ywy.popShow = true;
    },
    ywyCancel() {
      let that = this;
      that.ywy.popShow = false;
    },
    ywyConfirm(values) {
      let that = this;
      that.ywy.value = values;
      that.ywy.popShow = false;
      that.entIndex = 9;
    },
    ywyChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    getPhone() {
      //根据车牌号获取手机号
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getDriver,
        { carNumber: that.cheCode },
        successRes => {
          that.phone = successRes.data.driver_mobile;
          that.cheCode = successRes.data.driver_car_number;
          that.driverName = successRes.data.driver_name;
          that.driverIdnumber = successRes.data.driver_idnumber;
        }
      );
    },
    getOuByCus() {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOuByCus,
        { id: that.milkdeductamount.id },
        successRes => {
          that.erp.entityColumns = JSON.parse(successRes.data).data;
        }
      );
    },
    syjmb(checked) {
      //是否使用价目价格
      let that = this;
      if (checked && that.jmb.value == "") {
        that.$toast("请选择价目表");
        that.erp.jamubiao = false;
      }
      if (that.failCode != "") {
        Dialog.alert({
          title: "",
          message:
            "出库编码" +
            that.failCode +
            "的商品没有在该价目表中，如需使用价目表价格请将商品维护到该价目表中"
        }).then(() => {
          that.erp.jamubiao = false;
        });
      }
    },
    showDate() {
      this.popDateShow = true;
    },
    onDateConfirm(value) {
      const d = new Date(value);
      const resDate =
        d.getFullYear() +
        "-" +
        this.p(d.getMonth() + 1) +
        "-" +
        this.p(d.getDate());
      const resTime =
        this.p(d.getHours()) +
        ":" +
        this.p(d.getMinutes()) +
        ":" +
        this.p(d.getSeconds());
      this.birthday = resDate + " " + resTime;
      this.popDateShow = false;
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    goodcodeShow(item, index) {
      //选择业务编码部分
      let that = this;
      that.goodcodeindex = index;
      that.goodcodecolumns = item.goods_code.split(",");
      that.goodcodeshow = true;
    },
    goodcodeCancel() {
      let that = this;
      that.goodcodeshow = false;
    },
    goodcodeConfirm(values) {
      let that = this;
      that.goodcode[that.goodcodeindex] = values;
      that.goodcodeshow = false;
    },
    goodcodeChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    supplierShow(item, index) {
      //选择业务编码部分
      let that = this;
      that.supplierid[that.supplierindex] = [];
      that.supplierindex = index;
      for (var i = 0; i < item.listsup.length; i++) {
        let json = {};
        json["id"] = item.listsup[i].id;
        json["name"] = item.listsup[i].dictdataValue;
        that.suppliercolumns[i] = json;
      }
      that.suppliershow = true;
    },
    getGoodsPriceByPriceListIdAndGoodsId() {
      return false;
      let that = this;
      let goodsId = [];
      let json = {};
      let goodsCode = "";
      let code = [];
      for (var i = 0; i < that.orderGoods.length; i++) {
        json["goodsId"] = that.goodcode[i];
        json["unit_zhxs"] = that.orderGoods[i].unit_zhxs;
        goodsId[i] = json;
        goodsCode = goodsCode + that.goodcode[i];
        code[i] = that.goodcode[i];
      }
      //erp信息-获取价目表价格
      that.$api.post(
        that.jumuc.userCenter.getGoodsPriceByPriceListIdAndGoodsId,
        {
          priceId: that.jmb.id,
          goodsId: JSON.stringify(goodsId),
          goodsCode: goodsCode
        },
        successRes => {
          let data = JSON.parse(successRes.data).data;
          that.orderGoods = [];
          that.jmdata = data;
          for (var k = 0; k < that.data.orderGoods.length; k++) {
            let good = that.data.orderGoods[k];
            that.orderGoods[k] = good;
            for (var key in data) {
              if (that.goodcode[k] == key) {
                good["jmbjg"] = data[key];
                that.orderGoods[k] = good;
              }
            }
          }
          //判断返回数据是否完整
          var codes = "";
          for (var j = 0; j < code.length; j++) {
            if (data[code[j]] == null) {
              codes += code[j] + " ";
            }
          }
          that.failCode = codes;
        }
      );
    },
    getIsNotNull() {
      //同步erp 审核通过接口参数封装
      let that = this;
      that.isNotNull = "";

      //本次订单扣减奶款
      that.erpJson["finalDeductAmount"] = that.order.shouldPayPrice;

      if (that.erp.entityId == "") {
        //业务实体id
        that.isNotNull = "业务实体id不能为空";
        return false;
      }
      that.erpJson["cuxOu"] = that.erp.entityId;

      if (that.erp.entityValue == "") {
        //业务实体名称
        that.isNotNull = "业务实体名称不能为空";
        return false;
      }
      that.erpJson["cuxOuName"] = that.erp.entityValue;

      if (that.org.id == "") {
        //库id
        that.isNotNull = "业务库不能为空";
        return false;
      }
      that.erpJson["warehouseId"] = that.org.id;

      if (that.org.value == "") {
        //库名称
        that.isNotNull = "业务库名称不能为空";
        return false;
      }
      that.erpJson["warehouseName"] = that.org.value;

      /*if (that.dec.code == '') { //发运方式
                    that.isNotNull = '发运方式不能为空';
                    return false
                }*/
      that.erpJson["shippingMethodCode"] = that.dec.code;

      /* if (that.sec.code == '') { //承运人
                     that.isNotNull = '承运人不能为空';
                     return false
                 }*/
      that.erpJson["freightCarrierCode"] = that.sec.code;

      if (that.odt.value == "") {
        //订单类型名称
        that.isNotNull = "订单类型名称不能为空";
        return false;
      }
      that.erpJson["businessTypeName"] = that.odt.value;

      if (that.odt.id == "") {
        //订单类型id
        that.isNotNull = "订单类型id不能为空";
        return false;
      }
      that.erpJson["businessType"] = that.odt.id;

      if (that.jmb.value == "") {
        //价目表名称
        that.isNotNull = "价目表名称不能为空";
        return false;
      }
      that.erpJson["priceListName"] = that.jmb.value;

      if (that.jmb.id == "") {
        //价目表id
        that.isNotNull = "价目表id不能为空";
        return false;
      }
      that.erpJson["priceListId"] = that.jmb.id;

      if (that.ptm.value == "") {
        //付款条件名称
        that.isNotNull = "付款条件名称不能为空";
        return false;
      }
      that.erpJson["paymentTermName"] = that.ptm.value;

      if (that.ptm.id == "") {
        //付款条件id
        that.isNotNull = "付款条件id不能为空";
        return false;
      }
      that.erpJson["paymentTerm"] = that.ptm.id;

      if (that.ywy.value == "") {
        //业务员编码
        that.isNotNull = "业务员编码不能为空";
        return false;
      }
      that.erpJson["bmUserCode"] = that.ywy.value;

      /* if (that.fhInfo == '') { //发货信息补充
                     that.isNotNull = '发货信息补充不能为空';
                     return false
                 }*/
      that.erpJson["shipInfo"] = that.fhInfo;

      let goodcode = JSON.parse(localStorage.getItem("goodgys"));
      let str = "";
      for (var i = 0; i < goodcode.length; i++) {
        if (i == goodcode.length) {
          str = str + goodcode[i];
        } else {
          str = str + goodcode[i] + ",";
        }
      }
      if (str == "") {
        //供应商id
        that.isNotNull = "";
      }
      that.erpJson["supplerCode"] = str;

      let gz = JSON.parse(localStorage.getItem("goodRule"));
      let syncJxcCode = "";
      let syncErpCode = "";
      for (var i = 0; i < gz.length; i++) {
        if (gz[i].id == 1) {
          //同步进销存
          syncJxcCode = syncJxcCode + gz[i].code + ",";
        }
        if (gz[i].id == 2) {
          //同步ERP
          syncErpCode = syncErpCode + gz[i].code + ",";
        }
      }
      if (syncJxcCode != "") {
        syncJxcCode = syncJxcCode.substring(0, syncJxcCode.length - 1);
      }
      if (syncErpCode != "") {
        syncErpCode = syncErpCode.substring(0, syncErpCode.length - 1);
      }
      that.erpJson["syncJxcCode"] = syncJxcCode; //同步进销存
      that.erpJson["syncErpCode"] = syncErpCode; //同步ERP

      that.erpJson["sourceTypeCode"] = that.sourceTypeCode; //销转采订单
    },
    handleFormData(data) {
      let that = this;
      that.dataJson.deliveryPrice = data.deliveryPrice;
      that.dataJson.outCount = data.outCount;
      that.dataJson.receivedCount = data.receivedCount;
      that.sumPrice = 0;
      let outOrderDetail = that.delivery.outOrderDetail;
      for (var i = 0; i < outOrderDetail.length; i++) {
        that.sumPrice =
          that.sumPrice +
          data.deliveryPrice[i] * data.receivedCount[i] +
          outOrderDetail[i].freightPrice * data.receivedCount[i];
      }
    },
    handlejmbGoods(data) {
      this.jmbGoods = data;
    },
    getspeedy_input() {
      let that = this;
      that.speedy_input = that.speedy_input.replace(/，|,/g, ",");
      let arry = [];
      arry = that.speedy_input.split(",");
      that.cheCode = arry[2];
      that.birthday = arry[4];
      that.phone = arry[1];
      that.driverName = arry[0];
      that.driverIdnumber = arry[3];
    },
     onReadFiles(file, detail) {//上传附件
                let that = this;
                let fileFormData = new FormData();
                fileFormData.append('file', file.file)
                let delivery = 0
                fileFormData.append('fileType', 3)
                fileFormData.append('workflowId', that.data.workFlow.id)
                fileFormData.append('delivery', delivery)
                fileFormData.append('userId', localStorage.getItem("userId"))
                that.$api.post(that.data.uploadUrl, fileFormData, successRes => {
                    if (successRes.result) {
                        let workflowFileList = successRes.data
                        that.fileList=workflowFileList;
                        for (let i = 0; i < workflowFileList.length; i++) {
                            let json = {}
                            json['id'] = workflowFileList[i].picId
                            json['fileUrl'] = workflowFileList[i].url
                            json['file_type'] = workflowFileList[i].file_type
                            that.fileList[i] = json
                        }
                        that.$toast('上传成功!');
                    } else {
                        that.$toast('上传失败!');
                    }
                })
            },
        deImgeFiles(id) {
      let that = this;
      that.$api.get(that.data.deleteImgUrl, { picId: id }, successRes => {
        if (successRes.result) {
          that.fileList = [];
          let workflowFileList = successRes.data;
          for (let i = 0; i < workflowFileList.length; i++) {
            let json = {};
            json["id"] = workflowFileList[i].picId;
            json["fileUrl"] = workflowFileList[i].url;
            that.fileList[i] = json;
          }
          that.$toast("删除成功");
        } else {
          that.$toast("删除失败");
        }
      });
    },
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;

body {
  background: #f7f7ff;
}

#app .van-tabs__line {
  height: 45px;
  background-color: rgba(255, 255, 255, 0.1);
  min-width: 80px;
  left: -10px;
}

.appr-tabs {
  .van-tab {
    color: #fff;
  }
  .van-tabs__nav {
    background-color: @bule-thame;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}

.jump-warphd {
  /*.van-icon {
            color: @bule-thame;
        }*/
  .appr-item {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fff;
    h5 {
      font-size: 16px;
      padding-bottom: 10px;
      i {
        padding: 5px;
        background-color: @bule-thame;
        color: #fff;
        border-radius: 100%;
        margin-right: 5px;
      }
    }
    p {
      padding: 4px 0;
      font-size: 14px;
      &.item-r {
        color: #ccc;
        text-align: right;
      }
      span {
        min-width: 60px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    &-head {
      border-bottom: 1px #f7f7f7 solid;
      &-hd {
        position: relative;
      }
    }
    &-foot {
      border-top: 1px #f7f7f7 solid;
      p {
        color: #ccc;
      }
    }
    .item-arrow {
      border-top: 1px solid #f7f7f7;
      text-align: center;
      color: @bule-thame;
    }
    .line {
      display: block;
      border-bottom: 1px solid #f7f7f7;
    }
  }

  .pro-body {
    padding: 10px;
    .pro-item {
      margin-bottom: 10px;
      background-color: #fff;
      padding: 10px;
      h5 {
        font-size: 14px;
        padding-bottom: 10px;
        border-bottom: 1px solid #f7f7f7;
      }
      span {
        min-width: 60px;
        display: inline-block;
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        padding: 10px 0;
      }
      &-by {
        padding: 10px 0 0;
      }
      &-ft {
        background-color: #f7f7f7;
        padding: 10px;
      }
      .pro-edit {
        color: @bule-thame;
        text-decoration: underline;
        i {
          vertical-align: -2px;
        }
      }
    }
  }
  .pay-by {
    padding: 10px;
    .pay-item {
      background-color: #fff;
      padding: 10px;
      position: relative;
      margin-bottom: 10px;
      p {
        color: #ccc;
        font-size: 12px;
        padding: 5px 0;
      }
      &-ft {
        padding-top: 10px;
        p {
          color: #333;
        }
      }
      .pay-state {
        text-align: right;
        color: @bule-thame;
        i {
          display: inline-block;
          padding: 5px;
          border-radius: 100%;
          background-color: @bule-thame;
        }
      }
      &-rd {
        position: absolute;
        top: 0;
        left: -5px;
        width: 10px;
        height: 100%;
        background-color: @bule-thame;
        border-radius: 10px 0 0 10px;
      }

      &.ok {
        .pay-state {
          color: #28a745;
          i {
            background-color: #28a745;
          }
        }
        .pay-item-rd {
          background-color: #28a745;
        }
      }
      &.err {
        .pay-state {
          color: #ffc107;
          i {
            background-color: #ffc107;
          }
        }
        .pay-item-rd {
          background-color: #ffc107;
        }
      }
    }
  }
  .pay-hd-item {
    margin-bottom: 10px;
    .pay-hd-line {
      border-bottom: 1px solid #f7f7f7;
      margin-bottom: 10px;
    }
    .van-field {
      border: 1px solid #f7f7f7;
    }
  }

  .van-cell:not(:last-child)::after {
    border: none;
  }

  .apply {
    .van-field {
      margin: 10px 0;
      border: 1px solid #f7f7f7;
    }
    .van-col--8 {
      padding: 0 10px;
    }
    button {
      font-size: 14px;
      height: 40px;
      line-height: 38px;
      background-color: @bule-thame;
      border-color: @bule-thame;
    }
    button.danger {
      background-color: #ffc107;
      border-color: #ffc107;
    }
  }

  .item-body-warp {
    height: 60px;
    overflow: hidden;
    position: relative;
  }
  .item-body-warp.open {
    height: auto;
  }
}

.delete {
  font-size: 28px;
  position: absolute;
  margin-left: 25%;
}
</style>
